enum PATHS {
  BASE_PATH = 'wss://api.exchange.bitcoin.com/api/2/ws',
  WS_PATH = '/ws',
}

export default PATHS;
